import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledInboxNotice = {
  Card: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border-radius: 16px;
    background: rgba(215, 181, 85, 0.15);
  `,
  Image: styled.img`
    width: 54px;
    height: 54px;
    flex-shrink: 0;
  `,
  Info: styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  Title: styled.p`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.INK_DARKEST};
  `,
  Description: styled.p`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${Color.INK_LIGHT};
  `,
  Email: styled.span`
    font-weight: 400;
    color: ${Color.GREEN_DARKEST};
    overflow-wrap: anywhere;
  `,
}
